import { Form, notification } from 'antd';
import { FormItemProps, FormListProps, FormProps } from 'antd/lib/form';

const typeTemplate = '${label} is not a valid ${type}';

const validateMessages = {
  required: '${label} is required',
  types: {
    url: typeTemplate,
    email: typeTemplate,
  },
};

const CommonForm = ({ children, ...props }: FormProps) => {
  return (
    <Form
      {...props}
      onFinishFailed={handleShowToastMessageError}
      validateMessages={validateMessages}
    >
      {children as any}
    </Form>
  );
};

const openNotification = () => {
  const args = {
    message: 'Missing required fields',
    description: 'There are errors when fill data form. Please check again data filled.',
    duration: 3,
  };
  notification.error(args);
};

export const handleShowToastMessageError = (errorInfo: any) => {
  if (!errorInfo.errorFields.length) return;

  const errs = (errorInfo.errorFields || []).map((item: any) => item.errors[0]);
  if (errs.length) {
    openNotification();

    document.querySelector('.ant-form-item-has-error')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
};

const CommonFormItem = ({ children, ...props }: FormItemProps) => {
  return <Form.Item {...props}>{children}</Form.Item>;
};

const CommonFormList = ({ children, ...props }: FormListProps) => {
  return <Form.List {...props}>{children}</Form.List>;
};

const { useForm, Provider } = Form;

export {
  CommonForm as Form,
  CommonFormItem as FormItem,
  CommonFormList as FormList,
  Provider,
  useForm
};

